import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export default class Parallax {
  constructor() {
    this.mediaQuery = window.matchMedia('(min-width: 768px)');
    this.parallaxTriggers = [];

    this.debouncedRefresh = this.debounce(() => this.refresh(), 200);

    // パララックス要素がない場合はスルー
    const parallaxElements = gsap.utils.toArray('.js-parallax');
    if (!parallaxElements.length) {
      return;
    }
    else {
      this.init();
      this.setupResizeListener();
    }

  }

  // デバウンス関数
  debounce(fn, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  setupResizeListener() {
    this.mediaQuery.addEventListener('change', this.debouncedRefresh);
  }

  refresh() {
    // 既存のScrollTriggerをkillして配列クリア
    this.parallaxTriggers.forEach(trigger => trigger.kill());
    this.parallaxTriggers = [];
    ScrollTrigger.refresh();
    this.init();
  }

  init() {
    const isPC = this.mediaQuery.matches;

    gsap.utils.toArray('.js-parallax').forEach(wrap => {
      //画面幅に応じたdata-yをセット
      const y = isPC
        ? wrap.getAttribute('pc-data-y') || wrap.getAttribute('data-y') || -100
        : wrap.getAttribute('sp-data-y') || wrap.getAttribute('data-y') || -100;


      // js-parallax--centerクラスが付いている場合のみ中央寄せをセット
      if (wrap.classList.contains('js-parallax--center')) {
        gsap.set(wrap, { xPercent: -50 });
      }

      const tween = gsap.to(wrap, {
        y: y,
        scrollTrigger: {
          trigger: wrap,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1,
        }
      });

      this.parallaxTriggers.push(tween.scrollTrigger);
    });
  }
}
